import service from 'src/utils/request';

export interface googleLoginProps {
    code: string
    customDomain?: string
    redirectUri: string
}

// google 登录
export async function googleLoginRequest (data: googleLoginProps) {
  return await service({
    url: '/v1/user/googleLogin',
    method: 'post',
    data
  });
}

// 退出登录
export async function logoutRequest () {
  return await service({
    url: '/v1/user/logout',
    method: 'get'
  });
}

interface applyProps {
    reason: string
}
// 申请试用
export async function applyRequest (data: applyProps) {
  return await service({
    url: '/v1/user/apply',
    method: 'post',
    data
  });
}

// 获取用户申请状态
export async function isLoginRequest () {
  return await service({
    url: '/v1/user/isLogin',
    method: 'get'
  });
}

// 获取google client id
export async function getGoogleClientId (data: { customDomain: string }) {
  return await service({
    url: '/v1/user/pre-google-login',
    method: 'post',
    data
  });
}

interface reqGetProps {
  captchaType: string
  clientUid: string
  ts: number
}
// 获取验证图片  以及token
export async function reqGet (data: reqGetProps) {
  return await service({
    url: '/captcha/get',
    method: 'post',
    data
  });
}

interface reqCheckProps {
  captchaType: string
  pointJson: string
  token: string
}
// 滑动或者点选验证
export async function reqCheck (data: reqCheckProps) {
  return await service({
    url: '/captcha/check',
    method: 'post',
    data
  });
}

// 获取登录验证码
export async function sendSmsCode (params: { phone: string }) {
  return await service({
    url: '/v1/send/sms',
    method: 'get',
    params
  });
}

// 获取邮箱验证码
export async function sendEmailCode (params: { email: string }) {
  return await service({
    url: '/v1/send/email',
    method: 'get',
    params
  });
}

interface phoneLoginProps {
  phone: string
  smsCode: string
  captchaVerification: string
}
// 手机号登陆
export async function phoneLogin (data: phoneLoginProps) {
  return await service({
    url: '/v1/user/doLogin',
    method: 'post',
    data
  });
}

interface emailLoginProps {
  email: string
  code: string
  captchaVerification: string
}
// 邮箱登录
export async function emailLogin (data: emailLoginProps) {
  return await service({
    url: '/v1/user/email-login',
    method: 'post',
    data
  });
}
